const searchRules = {
  XssFiltered: (value) => /(^[?*+])|([[()\\])/g.test(value)
};
const typeCondition = ['VM','VM-GPU'];
export { searchRules, typeCondition };
